<skychute-bar-loader></skychute-bar-loader>
<skychute-logo-loader *ngIf="isLoading"></skychute-logo-loader>
<router-outlet></router-outlet>
